export default __webpack_public_path__ + "static/ArkadiuszKlenowski-5ebb73b629123e6aea900769545d8f32.png";